const Network = ({url, icon, name}) => <a className="hover:scale-110 transform transition-all ease-in-out duration-200 "href={url} target="__blank"><img className="lg:w-10 w-6" src={icon} alt={name}/></a>
export default Network